import React, { useState } from 'react'
import classnames from 'classnames'
import { DateTime } from 'luxon'

import { TtIcon } from '@23/react'

import { useInterval } from '../../../../../../sharedLegacy/hooks'

import './FocusClock.scss'

const FocusClock = () => {
  const [currentTime, setCurrentTime] = useState(Date.now())

  useInterval(() => {
    setCurrentTime(Date.now())
  }, 1000)

  return (
    <div className="focus-widget focus-clock">
      <TtIcon library="one" name="clock" />
      <span>
        {DateTime.fromMillis(currentTime).toFormat(`HH`)}
        <span
          className={classnames('focus-clock-separator', {
            hidden: Math.round(currentTime / 1000) % 2 === 0,
          })}
        >
          {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
          {}:
        </span>
        {DateTime.fromMillis(currentTime).toFormat(`mm`)}
      </span>
    </div>
  )
}
export { FocusClock }
